import * as React from "react";
import {
    Edit, SimpleForm, required, ReferenceInput, BooleanInput,
    FunctionField, TextInput, DateInput, SelectInput, NumberInput, FormDataConsumer,
    PasswordInput, usePermissions, useTranslate
} from 'react-admin';

// Components
import InputRow from '../components/form/InputRow';
import NoDeleteToolbar from '../components/form/NoDeleteToolbar';
import CitySelectInput from '../components/form/CitySelectInput';

// Constants
import COUNTRIES from '../constants/countries';
import GENDERS from '../constants/genders';
import { CROLES_ASSIGNABLE } from '../constants/croles';

// Entity
const entity = "users";

export const UserEdit = (props) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const isAdmin = permissions?.crole === 'admin';
    // Admin her alani duzenleyebilir; diger roller sadece acik alanlari
    const locked = !isAdmin;

    return (
    <Edit title={translate('ra.action.edit', { _: 'Düzenle' })} {...props}>
        <SimpleForm redirect={`/${entity}`} toolbar={<NoDeleteToolbar />}>
            <FunctionField source="name" render={r => `${r.name} ${r.surname}`} fontSize={25} />
            <hr />
            <h3>{translate('users.personal_info', { _: 'Kişisel Bilgiler' })}</h3>
            <InputRow>
                <TextInput source="name" fullWidth validate={required()} />
                <TextInput source="surname" fullWidth validate={required()} />
                <SelectInput source="gender" choices={GENDERS} fullWidth validate={required()} />
            </InputRow>
            <InputRow>
                <TextInput source="mobile" fullWidth validate={required()} />
                <TextInput
                    source="email"
                    fullWidth
                    validate={required()}
                    disabled={locked}
                    helperText={
                        isAdmin
                            ? translate('users.email_unique_help', { _: 'Benzersiz olmalıdır. Kullanıcı kaydettikten sonra bu e-posta ile giriş yapacaktır.' })
                            : undefined
                    }
                />
            </InputRow>
            <InputRow>
                <SelectInput source="country" choices={COUNTRIES} fullWidth validate={required()} disabled={locked} />
                <CitySelectInput source="city" fullWidth disabled={locked} defaultValue={null} />
            </InputRow>
            <InputRow>
                <DateInput source='createdate' fullWidth label={translate('users.membership_date', { _: 'Üyelik Tarihi' })} disabled={locked} />
                <DateInput source="dob" fullWidth validate={required()} disabled={locked} label={translate('users.dob', { _: 'Doğum Tarihi' })} />
            </InputRow>
            <BooleanInput source="newsletter" label={translate('users.newsletter', { _: 'Bülten Aboneliği' })} fullWidth validate={required()} />
            <BooleanInput source="isVerified" label={translate('users.is_verified', { _: 'Onaylı Kullanıcı' })} fullWidth validate={required()} />
            <NumberInput source="verificationCode" label={translate('users.verification_code', { _: 'Doğrulama Kodu' })} helperText={translate('users.verification_code_help', { _: 'Bu kodu değiştirdiğinizde kullanıcıya yeni bir doğrulama e-postası gönderilir.' })} />

            {isAdmin ? (
                <PasswordInput
                    source="password"
                    label={translate('users.new_password', { _: 'Yeni Şifre' })}
                    fullWidth
                    helperText={translate('users.new_password_help', { _: 'Mevcut şifreyi korumak için boş bırakın.' })}
                />
            ) : null}

            <h3>{translate('users.role_section', { _: 'Rol' })}</h3>
            <SelectInput
              source="crole"
              label={translate('users.role_label', { _: 'Rol' })}
              choices={CROLES_ASSIGNABLE}
              fullWidth
              emptyText={translate('users.no_role', { _: 'Rol yok' })}
              disabled={locked}
            />
            <FormDataConsumer>
                {({ formData }) => {
                    if (formData.crole === 'organisationCompanyManager') {
                        return (
                            <ReferenceInput source="rid" reference="organisationCompanies">
                                <SelectInput optionText="name" fullWidth label={translate('users.org_company_label', { _: 'Organizasyon Şirketi' })} disabled={locked} />
                            </ReferenceInput>
                        );
                    }
                    if (formData.crole === 'venueManager') {
                        return (
                            <ReferenceInput source="rid" reference="venues" perPage={200}>
                                <SelectInput optionText="name" fullWidth label={translate('users.venue_label', { _: 'Mekan' })} disabled={locked} />
                            </ReferenceInput>
                        );
                    }
                    return null;
                }}
            </FormDataConsumer>
        </SimpleForm>
    </Edit>
    );
};
